import SiteHeader from './SiteHeader';
import SiteSidebar from './SiteSidebar';
import SiteFooter from './SiteFooter';

interface SiteLayoutProps {
  children: React.ReactNode;
}

export default function SiteLayout({ children }: SiteLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <div className="flex-1 w-full px-4 md:px-6 py-6">
        <div className="flex gap-6">
          <SiteSidebar />
          <main className="flex-1 min-w-0">{children}</main>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}